module.exports = __webpack_public_path__ + "img/abecedar-1783-pagina-de-titlu-big.7f4b4c02.png";